import { createContext, useContext } from "react";

type PageHeaderSlotContextValue = {
  slot: HTMLElement | null;
  register: () => () => void;
};

export const PageHeaderSlotContext = createContext<PageHeaderSlotContextValue>({
  slot: null,
  register: () => () => {},
});

export const usePageHeaderSlot = (): PageHeaderSlotContextValue =>
  useContext(PageHeaderSlotContext);
